import { VIEW_MODE } from '@/types';

import { useDeviceLayout } from './useDeviceLayout';
import { useMapViewMode } from './useMapViewMode';

/**
 * Returns the SlidePanel visual variant based on current view mode.
 * 'docked' for list/kanban on desktop, 'floating' for map mode and mobile.
 *
 * Reads the active view from the URL via `useMapViewMode`, which already
 * resolves the effective view for the currently active background
 * artifact (tasks / notes / ...).
 */
export function useSlidePanelVariant(): 'floating' | 'docked' {
  const { isMobile } = useDeviceLayout();
  const { view } = useMapViewMode();

  if (isMobile) return 'floating';
  return view === VIEW_MODE.MAP ? 'floating' : 'docked';
}
